import { IFacebookTrackingAdminElement } from '@adminPortal/_common/_interfaces/IFacebookTrackingAdminElement';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { TrackingActions } from './tracking.actions';

export const trackingFeatureKey = 'tracking';

export interface TrackingState {
  totalItems: number;
  facebookTrackingList: IFacebookTrackingAdminElement[];
  loading: boolean;
  error: any;
}

export const initialState: TrackingState = {
  totalItems: 0,
  facebookTrackingList: [],
  loading: false,
  error: null,
};

export const trackingFeature = createFeature({
  name: trackingFeatureKey,
  reducer: createReducer(
    initialState,
    on(
      TrackingActions.createFacebookTracking,
      TrackingActions.loadFacebookTrackingList,
      TrackingActions.saveFacebookTracking,
      TrackingActions.deleteFacebookTracking,
      (state) => ({
        ...state,
        loading: true,
        error: null,
      })
    ),
    on(
      TrackingActions.loadFacebookTrackingListFailure,
      TrackingActions.createFacebookTrackingFailure,
      TrackingActions.saveFacebookTrackingFailure,
      TrackingActions.deleteFacebookTrackingFailure,
      (state, { error }) => ({
        ...state,
        loading: false,
        error,
      })
    ),
    on(TrackingActions.loadFacebookTrackingListSuccess, (state, { facebookTrackingList }) => ({
      ...state,
      facebookTrackingList,
      loading: false,
      error: null,
    })),
    on(
      TrackingActions.createFacebookTrackingSuccess,
      TrackingActions.deleteFacebookTrackingSuccess,
      TrackingActions.saveFacebookTrackingSuccess,
      (state) => ({
        ...state,
        loading: false,
        error: null,
      })
    )
  ),

  extraSelectors: ({ selectTrackingState }) => ({
    selectFacebookTrackingList: createSelector(
      selectTrackingState,
      (selectTrackingStateData) => selectTrackingStateData.facebookTrackingList
    ),
  }),
});
